import { LoaderCircle } from 'lucide-react'
import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

import logo6Bios from '@/assets/images/svgs/logo-6bios.svg'

interface LoadingLazyRoutesProps extends ComponentProps<'div'> {}
export function LoadingLazyRoutes({ className }: LoadingLazyRoutesProps) {
  return (
    <div
      className={twMerge(
        'h-screen w-screen flex-1 content-center bg-monochromatic-200',
        className,
      )}
    >
      <div className="space-y-10">
        <img src={logo6Bios} alt="" className="mx-auto" loading="lazy" />
        <LoaderCircle className="mx-auto size-12 animate-spin text-bios-primary" />
      </div>
    </div>
  )
}
